<template>
    <div class="row col-12 pr-0" v-if="resume_data['can_resume']">
        <div class="col-lg-12 pr-0">
            <hr class="colorgraph">
            <div class="px-3 py-2 user-information-section">
                <div class="head-title mb-2">
                    <strong>{{ $lang('Zgłoszenie zostało odrzucone') }}</strong>
                </div>
                <div v-if="resume_data.comments && resume_data.comments.length">
                    <p>{{$lang('Komentarz')}}</p>
                    <ul>
                        <li v-for="comment in resume_data.comments"><i>{{comment}}</i></li>
                    </ul>
                </div>
                <div>
                    <p>
                        <span>{{$lang('Masz możliwość złożenia prośby o ponowną analizę problemu.')}}</span><br>
                        <span>{{$lang('Opcja dostępna do')}}: <b>{{resume_data.until}}</b></span>
                    </p>
                </div>
                <div class="text-right mt-2">
                      <a class="btn btn-primary btn-sm" data-toggle="modal" data-target="#resumeReasonModal">{{$lang('Prośba o ponowną analizę')}}</a>
                </div>
            </div>
        </div>

        <div class="modal fade" id="resumeReasonModal" tabindex="-1" role="dialog"
             aria-labelledby="resumeReasonModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <form method="post" :action="resume_route" ref="resumeForm">
                        <input type="hidden" name="_token" v-bind:value="csrf">
                        <div class="modal-header">
                            <h5 class="modal-title"
                                id="resumeReasonModalTitle">{{ $lang('Powód reaktywacji zgłoszenia') }}</h5>
                            <button type="button" class="close" data-dismiss="modal"
                                    :aria-label="$lang('Zamknij')">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <label for="resumeReason">
                                    {{ $lang('Zgłoszenie zostanie poddane ponownej analizie. Proszę podać powód reaktywacji zgłoszenia:') }}
                                </label>
                                <textarea class="form-control mt-1" id="resumeReason" rows="3"
                                          name="resume_reason" v-model="resumeReason"></textarea>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default"
                                    data-dismiss="modal">{{ $lang('Anuluj') }}
                            </button>
                            <button type="button" class="btn btn-primary" :disabled="!resumeReasonGiven"
                                    @click.once="resume">
                                {{ $lang('Zatwierdź') }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        resume_data: {type: Object, required: true},
        task: {type: Object, required: true},
        resume_route: {type: String, required: true},
        csrf: {type: String, required: true},
    },
    data() {
        return {
            resumeReason: '',
        }
    },
    methods: {
        resume() {
            this.$refs.resumeForm.submit();
        }
    },
    computed: {
        resumeReasonGiven() {
            return this.resumeReason !== '' && this.resumeReason !== null;
        }
    }
}
</script>
